import React from "react";

const Hr = () => {
  return <hr className="h-px my-8 bg-gray-200 border-0 dark:bg-gray-700" />;
};

export default Hr;
